export const categories = [
  {
    slug: 'hot-news',
    name: '热点新闻',
    desc: '追踪娱乐圈最新热点，第一时间掌握明星与作品动态，快速了解今日大事。',
    icon: 'ri-fire-line',
    subcategories: [
      { slug: 'all', name: '全部' },
      { slug: 'star', name: '明星动态' },
      { slug: 'film', name: '影视资讯' },
      { slug: 'show', name: '综艺热播' },
      { slug: 'music', name: '音乐现场' },
    ],
  },
  {
    slug: 'expose',
    name: '爆料报道',
    desc: '深挖圈内爆料与独家线索，梳理事件来龙去脉，还原报道背后的关键细节。',
    icon: 'ri-alarm-warning-line',
    subcategories: [
      { slug: 'all', name: '全部' },
      { slug: 'exclusive', name: '独家爆料' },
      { slug: 'insider', name: '内幕追踪' },
      { slug: 'industry', name: '行业观察' },
    ],
  },
  {
    slug: 'web-fun',
    name: '网络趣闻',
    desc: '汇集网络热梗与花絮趣闻，轻松吃瓜不累，看看网友都在聊什么。',
    icon: 'ri-emotion-laugh-line',
    subcategories: [
      { slug: 'all', name: '全部' },
      { slug: 'moment', name: '名场面' },
      { slug: 'meme', name: '网友热议' },
      { slug: 'daily', name: '明星日常' },
    ],
  },
];

export const categoryMap = {
  'hot-news': '热点新闻',
  expose: '爆料报道',
  'web-fun': '网络趣闻',
};